import React, { Component } from 'react';
import logo from './logo.svg';
import ear from './ear_512x512.png';
import couchcast_logo from './couchcast_logo.png';

import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <input className="App-searchBox" value="Search"></input>
            <h1 className="App-title">Any game or live tv event...</h1>
        </header>
        <article>
          <img src={couchcast_logo} className="App-couchcast_logo" alt="couchcast_logo" />
        </article>
        <p className="App-intro">
          
        </p>
        <footer className="footer">
          <div className="App-footer">
            <button className="btn-footer" id="broadcastInput">Broadcast</button>
            <button className="btn-footer" id="listenInput">Listen</button>
          </div>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js